import React from 'react'
import {CrumplePopSignupContext} from '../contexts/CrumplePopSignupContext';
import {axiosGet} from '../../common/js/axios-utility';
import CrumplePopHubDownload from './CrumplePopHubDownload';
import CrumplePopLicenseTable from './CrumplePopSignin/CrumplePopLicenseTable';

export default function CrumplePopMigrationResults() {
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext)
    const [order, setOrder] = React.useState({});

    React.useEffect(() => {
        setMigrationState({...migrationState, processing: true});
        const fetchOrder = async () => {
            const {data} = await axiosGet('/cpop/migration_order');
            if (data.id != null){
                setOrder(data);
                setMigrationState({...migrationState, orderId: data.id, processing: false});
            }
            else{
                setMigrationState({...migrationState, processing: false});
            }
        }
        fetchOrder();
    }, [])

    return (
        <div>
            <CrumplePopHubDownload />
            {order.id && (
                <CrumplePopLicenseTable order={order} />
            )}
        </div>
    )
}
